// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/default.css
// module id = 140
// module chunks = 0